import * as Faker from 'app/utils/faker'
import { fromJS } from 'immutable'
import { PagedData } from 'utils/paging'
import { weakUuid } from 'app/modules/playbook/helpers'

const firstConversation = Faker.recentDate()

export const conversation = ({ conversationId = 110225, endUserId = 1 }) => ({
  "id": conversationId,
  "displayId": 50885,
  "type": "CHAT",
  "status": "OPEN",
  "orgId": 1,
  "inboxId": 17639,
  "endUserId": endUserId,
  "assigneeId": 0,
  "customerId": 0,
  "campaignId": 0,
  "subject": null,
  "uuid": "7148b44b-02d0-4d84-b6d8-2351595093dd",
  "slackChannel": "C91MGH021",
  "tags": [],
  "cc": [],
  "bcc": [],
  "source": null,
  "collaborators": [],
  "preview": "Thank you so much",
  "imported": false,
  "createdAt": firstConversation,
  "updatedAt": firstConversation,
  "closedAt": 0,
  "layerUrl": "layer+driftt:///conversation/pending",
  "defaultMessageDeliveryChannel": "CHAT",
  "context": {
    "campaign": {},
    "locale": "en",
    "os": {
      "name": "OS X 10.12.6",
      "version": "10.12.6",
      "family": "OS X",
      "architecture": "32"
    },
    "page": {
      "path": "",
      "referrer": "",
      "search": "",
      "title": "Drift Staging Profiles",
      "url": "team.driftqa.com",
      "href": "https://team.driftqa.com/"
    },
    "timezone": "America/New_York",
    "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/60.0.3112.101 Safari/537.36"
  },
  "slackAnnTimestamp": "1517409469.000025",
  "slackAnnChannelId": "C5W0NRPR9",
  "participantIds": [
  ],
  "matchedRuleId": 0,
  "possibleRuleIds": [],
  "flowContext": null,
  "relatedCampaignId": null,
  "unreadMessageCount": null,
  "user": {
    "id": 0,
    "type": "LEAD"
  }
})

// TODO: Parameterize same as above
export const conversations = [
  {
    "id": 110225,
    "displayId": 50885,
    "type": "CHAT",
    "status": "OPEN",
    "orgId": 1,
    "inboxId": 17639,
    "endUserId": 1,
    "assigneeId": 0,
    "customerId": 0,
    "campaignId": 0,
    "subject": null,
    "uuid": "7148b44b-02d0-4d84-b6d8-2351595093dd",
    "slackChannel": "C91MGH021",
    "tags": [],
    "cc": [],
    "bcc": [],
    "source": null,
    "collaborators": [],
    "preview": "Thank you so much",
    "imported": false,
    "createdAt": firstConversation,
    "updatedAt": firstConversation,
    "closedAt": 0,
    "layerUrl": "layer+driftt:///conversation/pending",
    "defaultMessageDeliveryChannel": "CHAT",
    "context": {
      "campaign": {},
      "locale": "en",
      "os": {
        "name": "OS X 10.12.6",
        "version": "10.12.6",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "",
        "referrer": "",
        "search": "",
        "title": "Drift Staging Profiles",
        "url": "team.driftqa.com",
        "href": "https://team.driftqa.com/"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/60.0.3112.101 Safari/537.36"
    },
    "slackAnnTimestamp": "1517409469.000025",
    "slackAnnChannelId": "C5W0NRPR9",
    "participantIds": [
    ],
    "matchedRuleId": 0,
    "possibleRuleIds": [],
    "flowContext": null,
    "relatedCampaignId": null,
    "unreadMessageCount": null,
    "user": {
      "id": 0,
      "type": "LEAD"
    }
  }
]

const makeEnrichmentData = () => {
  return {
    category: {
      industry: "Internet Software & Services",
      subIndustry: "Internet Software & Services",
    },
    geography: {
      city: "Boston",
      country: "United States",
      countryCode: "US",
      state: "Massachusetts",
    },
    location: "4 Copley Pl, Boston, MA 02116, USA",
    logo: "https://logo.clearbit.com/wayfair.com",
    metrics: {
      raised: 0,
      revenueRange: null,
      employees: 7030,
    },
    name: Faker.companyName(),
    social: {
      linkedin: {
        handle: "company/wayfair"
      },
      twitter: {
        handle: "Wayfair"
      },
    },
    source: "DEMANDBASE",
    url: "http://wayfair.com",
  }
}

// TODO: Augment with Geolocation Data
const makeEnrichedEndUser = ({ id }) => {
  return {
    id,
    orgId: 1,
    status: 'ENABLED',
    attributes: {},
    name: Faker.fullName(),
    email: Faker.email(),
    avatarUrl: Faker.avatar(),
    primaryIdentity: weakUuid(),
    externalId: weakUuid(),
    type: 'END_USER',
    enrichmentData: makeEnrichmentData(),
  }
}

const makeEnrichedConversation = ({ id, inboxId, participantIds, conversationStatuses, updatedAt, }) => {
  const endUser = makeEnrichedEndUser({ id })
  const normalizedParticipantIds = participantIds
    ? participantIds === '0'
      ? []
      : participantIds.map(parseInt)
    : [] // TODO: Random participants

  return {
    id,
    type: 'CHAT',
    status: (conversationStatuses && Faker.randomChoice(conversationStatuses)) || 'OPEN',
    orgId: 1,
    inboxId,
    endUserId: endUser.id,
    endUserType: endUser.type,
    preview: 'Thank you so much',
    participantIds: normalizedParticipantIds,
    updatedAt,
    endUser,
    user: {
      id: endUser.id,
      type: endUser.type,
    },
  }
}

const makeEnrichedConversations = ({ inboxId, limit, sortBy, before, after, participantIds, conversationStatuses }) => {
  // TODO: Restrict timestamps to specific min/max based on sortBy param
  // e.g. moment(Date.now()).subtract(1, 'days') for min/max
  const updatedAt = Date.now()
  return _.range(limit).map(index => makeEnrichedConversation({ id: index + 1, inboxId, participantIds, conversationStatuses, updatedAt }))
}

export const makeEnrichedPaginatedConversations = ({ inboxId, query }) => {
  const {
    limit,
    before,
    after,
    sortBy,
    participantId: participantIds,
    status: conversationStatuses,
  } = query

  const enrichedConversations = makeEnrichedConversations({
    inboxId,
    limit,
    sortBy,
    before,
    after,
    participantIds,
    conversationStatuses,
  })

  const sorted = _.sortBy(enrichedConversations, ({ updatedAt }) => {
    return (sortBy === 'oldest') ? updatedAt : -updatedAt
  })

  return PagedData({
    data: fromJS(sorted),
    cursor: _.last(sorted).updatedAt,
    hasMore: true,
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/demodata.js